var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.callHistory.callId
    ? _c("div", { staticClass: "hover-shadow box-border-7" }, [
        _c("div", [_c("span", [_vm._v(_vm._s(_vm.value))])]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(
              _vm._s(_vm.callHistory.caller) +
                " " +
                _vm._s("0" == _vm.callHistory.callType ? "呼入" : "呼出") +
                " " +
                _vm._s(_vm.callHistory.called)
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", [
            _vm._v(
              _vm._s(_vm.timeFrom) +
                " - " +
                _vm._s(_vm.timeDiff) +
                " - " +
                _vm._s(_vm.timeTo)
            )
          ])
        ]),
        _vm._v(" "),
        _c("audio", {
          staticStyle: { height: "25px" },
          attrs: {
            controls: "",
            preload: "meta",
            src: _vm.callHistory.recordUrl
          }
        }),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("客户姓名:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.callCustomer.name))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("电话:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.callCustomer.phone))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("地址:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.callCustomer.address))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("备注:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.callCustomer.memo))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("公司:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.callCustomer.company))])
        ])
      ])
    : _c("el-input", {
        staticStyle: { width: "100%" },
        attrs: { placeholder: "工单关联的当次呼叫信息" },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-762efa9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-762efa9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketWidgetCallInfo.vue
// module id = 942
// module chunks = 75